import React, { useState, useEffect, useRef, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import { format, startOfMonth, endOfMonth, eachDayOfInterval, addMonths, subMonths, isSameDay, isBefore, isAfter } from "date-fns";
import PersonIcon from "../../../assets/images/icons/person.svg";
import CreateMusicIcon from "../../../assets/images/icons/create-music.svg";
import MusicMikeIcon from "../../../assets/images/icons/music-mike.svg";
import UserGroupIcon from "../../../assets/images/icons/user-group.svg";
import UserChatIcon from "../../../assets/images/icons/user-chat.svg";
// import PointerClickIcon from "../../../assets/images/icons/pointer-click.svg";
// import PeopleIcon from "../../../assets/images/icons/people.svg";
// import UserCheckIcon from "../../../assets/images/icons/people-check.svg";
// import GroupIcon from "../../../assets/images/icons/group-user.svg";
// import MailUpIcon from "../../../assets/images/icons/mail-up.svg";
// import MailOpenIcon from "../../../assets/images/icons/mail-open.svg";
// import MailMinus from "../../../assets/images/icons/mail-minus.svg";
// import ClickIcon from "../../../assets/images/icons/click-icon.svg";
import { YourLinks } from "./components/YourLinks";
import { Dashboard } from "./components/Dashboard";
import { FutureSave } from "./components/FutureSave";
import { Fanbase } from "./components/Fanbase";
// import { FanEngagement } from "./components/FanEngagement";
import ComingSoonPage from "./components/ComingSoonPage"
// import StatsCard from "./components/StatsCard";
// import { Mail } from "lucide-react";
import { showToast } from "../../../helper/ShowToast";
import { useSelector } from "react-redux";
import { PricingPlanModal } from "../../../components/PricingPlanModal";
import { useDownloadOverallAudienceCsv } from "../../../queries/artistManger/smartLink.query";
import { useBioLinkStatus } from "../../../queries/artistManger/smartLink.query";
import { ToastContainer } from "react-toastify";
import AppTour from "../../../components/AppTour/AppTour";
import ArtistManagerDspLockOverlay from "../ArtistManager/ArtistManagerDspLockOverlay";
import {
    hasArtistLinked,
    hasFullLinksFanHubAccess,
} from "../../../helper/access";

import { linkAndFanHubTourSteps } from "../../../components/AppTour/ModuleTourSteps";

const tabs = [
    { id: "yourLinks", label: "Your Links" },
    { id: "dashboard", label: "Dashboard" },
    { id: "futureSave", label: "Future Save" },
    { id: "fanbase", label: "Fanbase" },
    { id: "fanEngagement", label: "Fan Engagement" },
];

export const LinkAndFanHub = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { hash } = location;
    const [activeTab, setActiveTab] = useState("yourLinks");
    const [runTour, setRunTour] = useState(false);
    const [showPricingPlanModal, setShowPricingPlanModal] = React.useState(false);
    const billing = useSelector((state) => state.billing);
    const access = useSelector((state) => state.auth.access);
    const userDetails = useSelector((state) => state.auth.userDetails);

    const needsLinkArtist = !hasArtistLinked(access, userDetails);
    const hasFullLinksAccess = useMemo(
        () => hasFullLinksFanHubAccess(access, userDetails, billing),
        [access, userDetails, billing]
    );

    useEffect(() => {
        if (!location.state?.openGoPro) return;

        setShowPricingPlanModal(true);
        navigate(`${location.pathname}${location.hash || ""}`, {
            replace: true,
            state: {},
        });
    }, [location.state?.openGoPro, location.pathname, location.hash, navigate]);

    const { data: bioLinkStatus, isLoading: isBioLinkStatusLoading } = useBioLinkStatus({
        enabled: hasFullLinksAccess,
    });

    // for download csv
    const {
        isPending: isAudienceDownloading,
        mutate: downloadAudienceCsv
    } = useDownloadOverallAudienceCsv();

    const TAB_STEP_MAP = {
        6: "yourLinks",
        8: "dashboard",
        15: "futureSave",
        18: "fanbase",
        20: "fanEngagement",
    };

    const handleTourCallback = (data) => {
        const { type, index, action, status } = data;

        if (status === "finished" || status === "skipped") {
            setRunTour(false);
            return;
        }

        // Switch tab AFTER the current step action (Next/Back),
        // targeting the step we're moving TO — so tab is ready before Joyride positions the tooltip
        if (type === "step:after") {
            const nextIndex = action === "prev" ? index - 1 : index + 1;
            if (TAB_STEP_MAP[nextIndex] !== undefined) {
                setActiveTab(TAB_STEP_MAP[nextIndex]);
            }
        }
    };

    const handleGatedAction = (onAllowed) => {
        if (needsLinkArtist) {
            showToast("info", "Link your artist profile to unlock Links & Fan Hub.");
            navigate("/link-accounts");
            return;
        }
        if (!hasFullLinksAccess) {
            showToast("info", "Please subscribe to unlock Links & Fan Hub.");
            setShowPricingPlanModal(true);
            return;
        }
        onAllowed();
    };

    const engageFan = () => {
        handleGatedAction(() => {
            showToast("info", "Work in progress");
        });
    };

    const createBioLink = () => {
        handleGatedAction(() => {
            if (isBioLinkStatusLoading || !bioLinkStatus) return;
            if (bioLinkStatus.exists) {
                navigate(`/admin/artist-manager/edit-bio-link/${bioLinkStatus.data._id}`);
            } else {
                navigate("/admin/artist-manager/build-bio-link");
            }
        });
    };

    const createMusicLink = () => {
        handleGatedAction(() => navigate("/admin/artist-manager/build-music-link"));
    };

    const createTourLink = () => {
        handleGatedAction(() => navigate("/admin/artist-manager/build-tour-link"));
    };

    const createPreSave = () => {
        handleGatedAction(() => navigate("/admin/artist-manager/create-pre-save"));
    };

    const handleLinkArtistClick = () => navigate("/link-accounts");
    const handleSubscribeClick = () => setShowPricingPlanModal(true);

    const tabBodyRef = useRef(null);
    const [isScrolled, setIsScrolled] = useState(false);
    const [isCollapsedMobile, setIsCollapsedMobile] = useState(false);

    useEffect(() => {
        const el = tabBodyRef.current;
        if (!el) return;

        const onScroll = () => {
            const scrolled = el.scrollTop > 8;
            setIsScrolled(scrolled);
            // collapse info-card on mobile when user scrolls down
            if (window.innerWidth < 768) {
                setIsCollapsedMobile(el.scrollTop > 20);
            } else {
                setIsCollapsedMobile(false);
            }
        };

        el.addEventListener('scroll', onScroll, { passive: true });
        return () => el.removeEventListener('scroll', onScroll);
    }, []);

    const handleDownloadCsv = () => {
        if (!hasFullLinksAccess) return;
        if (activeTab === "fanbase") {
            downloadAudienceCsv();
        }
    };

    useEffect(() => {
        if (hash === "#start-tour") {
            setRunTour(true)
        }
    }, [hash])

    // allow deep-linking to a specific tab, e.g. /admin/artist-manager/link-and-fan-hub#fanbase
    useEffect(() => {
        const tabId = hash?.replace("#", "");
        if (tabId && tabs.some((tab) => tab.id === tabId)) {
            setActiveTab(tabId);
        }
    }, [hash])

    return (
        <div className="LinkAndFanHub-Page font-jakarta py-4">
            <ToastContainer />
            <AppTour
                tourSteps={linkAndFanHubTourSteps}
                runTour={runTour}
                setRunTour={setRunTour}
                callback={handleTourCallback}
            />
            <div className="container max-w-full flex flex-col overflow-hidden">
                <div id="tour-info-card" className={`info-card bg-theme_clr1 font-jakarta font-bold rounded-xl mb-4 2xl:mb-5 ${isScrolled ? 'shadow-md' : ''} ${isCollapsedMobile ? 'p-2 lg:p-5' : 'p-4 lg:p-5'}`}>
                    <h5 className={`text-white ${isCollapsedMobile ? 'text-[18px]' : 'text-[23px]'} leading-tight mb-3`}>Links and Fan Hub</h5>
                    <div className={`text-theme_clr2 ${isCollapsedMobile ? 'text-sm mb-2' : 'text-lg mb-4'}`}>Own your audience and grow with our customizable website builder.</div>
                    <div className="btn-wrapper flex flex-col sm:flex-row sm:flex-wrap gap-2 lg:gap-4 xl:gap-5">
                        <button id="tour-bio-link" onClick={createBioLink} className="btn-custom flex text-nowrap items-center justify-center gap-1 !text-base !rounded-full"><img src={PersonIcon} alt="Person Icon" />{hasFullLinksAccess && bioLinkStatus?.exists ? "Edit" : "Create"} Bio Link</button>
                        <button id="tour-music-link" onClick={createMusicLink} className="btn-custom flex text-nowrap items-center justify-center gap-2 !text-base !rounded-full"><img src={CreateMusicIcon} alt="Create Music Icon" /> Create Music Link</button>
                        <button id="tour-tour-link" onClick={createTourLink} className="btn-custom flex text-nowrap items-center justify-center gap-2 !text-base !rounded-full"><img src={MusicMikeIcon} alt="Music Mike Icon" /> Create Tour Link</button>
                        <button id="tour-pre-save" onClick={createPreSave} className="btn-custom flex text-nowrap items-center justify-center gap-2 !text-base !rounded-full"><img src={UserGroupIcon} alt="User Group Icon" /> Create Pre Save</button>
                        {activeTab === "fanEngagement"
                            ? <button id="tour-message-fans" className="btn-custom flex text-nowrap items-center justify-center gap-2 opacity-50 !text-base !rounded-full" onClick={engageFan}><img src={UserChatIcon} alt="User Chat Icon" /> Engage Your Fans</button>
                            : <button id="tour-message-fans" className="btn-custom flex text-nowrap items-center justify-center gap-2 opacity-50 !text-base !rounded-full" onClick={engageFan}><img src={UserChatIcon} alt="User Chat Icon" /> Message Your Fans</button>}
                    </div>
                </div>

                {/* Stats Card Grid Section */}
                {/* {(activeTab === "futureSave" || activeTab === "fanbase") &&
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                        <StatsCard
                            label={"Fan Emails"}
                            value={32}
                            percentage={"0.0%"}
                            icon={PeopleIcon}
                        />
                        <StatsCard
                            label={"Future Saves"}
                            value={11}
                            percentage={"0.0%"}
                            icon={UserCheckIcon}
                        />
                    </div>
                } */}

                {/* {(activeTab === "fanEngagement") &&
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 mb-4">
                        <StatsCard
                            label={"Total Fans Reached"}
                            value={32}
                            percentage={"0.0%"}
                            icon={GroupIcon}
                            forEngagement
                        />
                        <StatsCard
                            label={"Total Message Sent"}
                            value={32}
                            percentage={"0.0%"}
                            icon={MailUpIcon}
                            forEngagement
                        />
                        <StatsCard
                            label={"Avg. Open Rate"}
                            value={32}
                            percentage={"0.0%"}
                            icon={MailOpenIcon}
                            forEngagement
                        />
                        <StatsCard
                            label={"Avg. CTR"}
                            value={32}
                            percentage={"0.0%"}
                            icon={ClickIcon}
                            forEngagement
                        />
                        <StatsCard
                            label={"Unsubscribes"}
                            value={32}
                            percentage={"0.0%"}
                            icon={MailMinus}
                            forEngagement
                        />
                    </div>
                } */}

                {/* Tabs Navigation Section Layout */}
                <div className="border-[2px] border-theme_clr1 rounded-xl tabs-content-wrapper px-3 md:px-4 flex flex-col flex-1 overflow-hidden">
                    <div className={`tab-header border-b border-theme_clr2 dark:border-theme_clr2 mb-2 sticky top-0 z-10 bg-white ${isScrolled ? 'shadow-sm' : ''}`}>
                        <div className="flex items-center justify-between gap-4">
                            <div className="flex-1 overflow-auto">
                                <ul className="flex flex-nowrap gap-4 lg:gap-8 text-base font-jakarta font-bold text-left overflow-auto whitespace-nowrap">
                                    {tabs.map((tab) => (
                                        <li key={tab.id} id={`tour-tab-${tab.id}`} className="inline-block">
                                            <button onClick={() => setActiveTab(tab.id)}
                                                className={`inline-block py-3 px-1 border-b-2 transition-all duration-200 text-nowrap ${activeTab === tab.id
                                                    ? "text-theme_clr1 border-theme_clr4"
                                                    : "text-theme_clr1 text-opacity-70 border-transparent"
                                                    }`}>
                                                {tab.label}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {(activeTab === "fanbase" || activeTab === "fanEngagement") && hasFullLinksAccess && (
                                <div className="flex items-center gap-6 ml-4">
                                    <button
                                        onClick={handleDownloadCsv}
                                        disabled={isAudienceDownloading}
                                        className="hidden sm:inline text-theme_clr4 font-semibold"
                                    >
                                        {isAudienceDownloading
                                            ? "Downloading..."
                                            : "Download CSV"}
                                    </button>
                                    <button className="text-theme_clr4 font-semibold">Import Fans</button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div ref={tabBodyRef} className="font-jakarta tab-body content-wrapper overflow-auto flex-1 min-h-0 py-2 relative">
                        <div
                            className={
                                hasFullLinksAccess
                                    ? ""
                                    : "pointer-events-none select-none blur-sm min-h-[280px]"
                            }
                        >
                        {activeTab === "yourLinks" && (
                            <YourLinks queriesEnabled={hasFullLinksAccess} />
                        )}

                        {activeTab === "dashboard" && (
                            <Dashboard queriesEnabled={hasFullLinksAccess} />
                        )}

                        {activeTab === "futureSave" && (
                            <FutureSave queriesEnabled={hasFullLinksAccess} />
                        )}

                        {activeTab === "fanbase" && (
                            <Fanbase queriesEnabled={hasFullLinksAccess} />
                        )}
                        {activeTab === "fanEngagement" && <ComingSoonPage />}
                        </div>
                        {!hasFullLinksAccess && (
                            <ArtistManagerDspLockOverlay
                                needsLinkArtist={needsLinkArtist}
                                onLinkArtist={handleLinkArtistClick}
                                onSubscribe={handleSubscribeClick}
                                verticalAlign={
                                    activeTab === "dashboard" || activeTab === "futureSave"
                                        ? "top"
                                        : "center"
                                }
                                title={needsLinkArtist ? "Link Your Artist" : "Unlock Links & Fan Hub"}
                                description={
                                    needsLinkArtist
                                        ? "Link your artist profile to unlock your fan hub and link analytics."
                                        : "Subscribe to unlock your fan hub and link analytics."
                                }
                            />
                        )}
                    </div>
                </div>
            </div>
            <PricingPlanModal
                isOpen={showPricingPlanModal}
                onClose={() => setShowPricingPlanModal(false)}
                returnUrl={window.location.origin + "/admin/artist-manager/link-and-fan-hub"}
            />
        </div>
    )
}